
import {BsFillLuggageFill} from 'react-icons/bs';
import {FaGift, FaRegSnowflake} from 'react-icons/fa';
import {GiFullMotorcycleHelmet} from 'react-icons/gi';

import Product1 from '../../assets/BusinessCard/bag2.jpg';
import Product3 from '../../assets/BusinessCard/bag3.jpg';
import Product2 from '../../assets/BusinessCard/bag5.jpeg';
import elan from '../../assets/BusinessCard/elan.webp';
import kalapiLogo from '../../assets/BusinessCard/logo11.png';
import logo from '../../assets/BusinessCard/MainLogo2.png';
import motherland from '../../assets/BusinessCard/motherlandlogo.svg';
import Naturals from '../../assets/BusinessCard/NaturalsLogo.svg';
import bgImage from '../../assets/BusinessCardBgImg.jpeg';

const BusinessCard = () => {
  return (
    <div className={'flex w-full flex-col justify-center'}>

      <div
        className={'relative min-h-screen bg-cover bg-center bg-blend-darken flex items-center justify-center md:px-4'}
        style={{backgroundImage: `url(${bgImage})`}}
      >
        <div className={'absolute inset-0 bg-black/40'}></div>

        <div className={'md:relative flex flex-col md:flex-row items-center justify-center w-full md:mt-10 max-w-6xl min-h-[700px] md:h-[600px] '}>
          <div
            className={`
        animate-fade-in-up
        relative md:absolute 
        bg-primary-50 text-primary-950 
        md:w-[70%] w-[75%] max-w-[350px] md:max-w-none
        h-auto md:h-[55%] 
        p-6 md:p-8 
        shadow-2xl flex flex-col gap-6 md:gap-10
        md:left-0 md:top-0
      `}
          >
            <h1 className={'text-4xl md:text-7xl font-bold'}>
              <img src={logo} alt={'Logo'} className={'md:w-72 w-48 h-auto'} />
            </h1>

            <div className={'md:w-2/3 w-full opacity-80'}>
              <p className={'md:text-lg text-sm font-medium font-instrument'}>
          Kalapi is a customer-focused business specializing in the manufacturing and supply of high-quality bags.
          We cater to both wholesale and retail markets, ensuring that our products are accessible to a wide range of customers.
              </p>
            </div>
          </div>

          {/* blue Card */}
          <div
            className={`
        animate-fade-in-down
        relative 
        bg-primary-800 text-white font-medium font-instrument 
        md:w-[66%] w-[75%] max-w-[350px] md:max-w-none
        h-auto md:h-[58%]
        p-6 md:p-10 
        shadow-2xl
        md:left-[320px] md:top-[100px]
      `}
          >
            <h2 className={'text-2xl md:text-5xl font-semibold leading-tight'}>
        Ashish <br /> Turakhia 
            </h2>

            <p className={'text-primary-200 mt-2 mb-6 text-sm md:text-base'}>Owner</p>

            <div className={'grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 text-sm'}>
              <div>
                <p className={'text-primary-200 text-xs'}>PHONE NUMBER</p>
                <p className={'text-primary-50'}>+91 9422051275</p>
              </div>

              <div>
                <p className={'text-primary-200 text-xs'}>EMAIL ADDRESS</p>
                <p className={'text-primary-50'}>contact@kalapi.store</p>
              </div>

              <div className={''}>
                <p className={'text-primary-200 text-xs'}>WEBSITE</p>
                <p className={'text-primary-50'}>https://www.kalapi.store/</p>
              </div>

              <div className={''}>
                <p className={'text-primary-200 text-xs'}>ADDRESS</p>
                <p className={'text-primary-50'}>
            18/63 Shivaji Road, Near Padma Talkies, Shivaji Putala, <br />
            Kolhapur, Maharashtra 416002
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className={'w-full py-16 p-2 flex justify-center'}>
        <div className={'max-w-6xl w-full px-4'}>

          <div className={'grid md:grid-cols-1 gap-14 items-center'}>

            <div className={'text-black animate-fade-in-up'}>
              <span className={'inline-block px-4 py-1 mb-4 text-sm font-semibold tracking-wide uppercase rounded-full bg-primary-100 text-primary-800'}>
        Premium Collection
              </span>

              <h1 className={'text-4xl md:text-5xl font-extrabold mb-6 leading-tight'}>
        Products & Services
              </h1>

              <p className={'text-gray-600 md:text-lg text-base leading-relaxed mb-8'}>
        We offer a diverse collection of bags designed for everyday use,
        travel, and customized needs. Our products combine durability,
        functionality, and modern design to match every lifestyle.
              </p>

              <div className={'grid md:grid-cols-2 grid-cols-1 md:gap-6 gap-4'}>

                {/* Seasonal */}
                <div className={'bg-white p-5 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 border border-primary-100'}>
                  <h3 className={'md:text-2xl text-xl flex text-center gap-2 font-bold text-primary-950 mb-2'}>
                    <FaRegSnowflake className={'mt-1'} /> Seasonal Items
                  </h3>
                  <p className={'text-[#525252] font-medium'}>
           Jackets, Sweaters, Wind Cheaters, Raincoats , All 11 coason Jackets , Umbrella , Caps , Thermal Ware
                  </p>
                </div>

                {/* Corporate */}
                <div className={'bg-white p-5 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 border border-primary-100'}>
                  <h3 className={'md:text-2xl text-xl flex gap-2 font-bold text-primary-950 mb-2'}>
                    <FaGift className={'mt-1'} /> Corporate Giftings
                  </h3>
                  <p className={'text-[#525252] font-medium'}>
            Premium products from Borosil, Milton, Cello, Prestige,
            LA Opala and more.
                  </p>
                </div>

                {/* Luggage */}
                <div className={'bg-white p-5 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 border border-primary-100'}>
                  <h3 className={'md:text-2xl text-xl flex gap-2 font-bold text-primary-950 mb-2'}>
                    <BsFillLuggageFill /> Luggage & Bags
                  </h3>
                  <p className={'text-[#525252] font-medium'}>
            Hard & Soft Trolley Bag , Duffle, Backpacks, School Bags, Travel Bags, Hand Bags,
            Sling Bag , Trekking Sacks.
                  </p>
                </div>

                {/* Safety */}
                <div className={'bg-white p-5 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 border border-primary-100'}>
                  <h3 className={'md:text-2xl text-xl flex gap-2 font-bold text-primary-950 mb-2'}>
                    <GiFullMotorcycleHelmet className={'mt-1'} />
 Safety Products
                  </h3>
                  <p className={'text-[#525252] font-medium'}>
            Helmets and Gumboots 
                  </p>
                </div>
              </div>
            </div>

            <div className={'grid md:grid-cols-2 grid-cols-1 md:gap-10 gap-6'}>
              <div className={'flex md:flex-col flex-row gap-6'}>
                <img
                  src={Product3}
                  alt={'Brand'}
                  className={'animate-fade-in-up w-full md:h-[350px] h-[200px] object-cover rounded-lg'}
                  style={{animationDelay: '0.1s'}}
                />
                <img
                  src={Product1}
                  alt={'Product'}
                  className={'animate-fade-in-up w-full md:h-[350px] h-[200px] object-cover rounded-lg'}
                  style={{animationDelay: '0.2s'}}
                />
              </div>

              <div className={'flex flex-col justify-end'}>
                <img
                  src={kalapiLogo}
                  alt={'Kalapi Logo'}
                  className={
                    'animate-fade-in md:w-[380px] w-[420px] mx-auto md:mb-12 mb-4 object-contain'
                  }
                />
                <img
                  src={Product2}
                  alt={'Bag'}
                  className={
                    'animate-fade-in-up col-span-2 w-full md:h-[550px] h-[350px] object-cover rounded-lg'
                  }
                  style={{animationDelay: '0.3s'}}
                />
              </div>
              
            </div>
          </div>
        </div>
      </div>

      <div className={'max-w-6xl mx-auto px-4 py-12'}>

        <div className={' mb-4 animate-fade-in-up'}>
          <h1 className={'text-4xl md:text-5xl font-bold text-black mb-6'}>
      Distributors & Wholesalers
          </h1>
          <p className={'text-base md:text-lg leading-relaxed max-w-3xl'}>
      We specialize in supplying high-quality products under brands like 
            <span className={'font-semibold'}> Motherland , Naturals, Elan, and Vevey</span>. 
            <br />
      As a trusted distributor, we focus on building strong and long-term relationships with our partners.
          </p>
        </div>

        <div className={'grid grid-cols-1 p-2 sm:grid-cols-2 md:grid-cols-3 gap-8'}>

          <div className={'animate-fade-in-up bg-white shadow-md rounded-2xl p-6 text-center hover:shadow-lg transition'} style={{animationDelay:'0.1s'}}>
            <img src={motherland} alt={'Motherland'} className={'h-20 mx-auto mb-4 object-contain'} />
            <h3 className={'text-xl font-semibold mb-2'}>Motherland </h3>
            <p className={'text-gray-600 text-sm'}>
Reliable and versatile bags offering strong build quality and practical designs. Ideal for both retail and wholesale needs.            </p>
          </div>

          <div className={'animate-fade-in-up bg-white shadow-md rounded-2xl p-6 text-center hover:shadow-lg transition'} style={{animationDelay:'0.2s'}}>
            <img src={elan} alt={'Elan'} className={'h-20 mx-auto mb-4 object-contain'} />
            <h3 className={'text-xl font-semibold mb-2'}>Elan</h3>
            <p className={'text-gray-600 text-sm'}>
       Stylish and modern bags crafted for functionality and elegance. Perfect for daily use with a focus on quality and contemporary design.
            </p>
          </div>

          <div className={'animate-fade-in-up bg-white shadow-md rounded-2xl p-6 text-center hover:shadow-lg transition'} style={{animationDelay:'0.3s'}}>
            <img src={Naturals}  alt={'Naturals'} className={'h-20 mx-auto mb-4 object-contain'} />
            <h3 className={'text-xl font-semibold mb-2'}>Naturals</h3>
            <p className={'text-gray-600 text-sm'}>
            Premium eco-friendly bags made with natural and sustainable materials. Designed for durability, everyday use, and a greener lifestyle.
            </p>
          </div>

        </div>

        <div className={'mt-4 animate-fade-in'}>
          <p className={'text-base md:text-lg  mt-4 max-w-3xl'}>
      We deal in both wholesale and retail, ensuring flexible supply options for businesses of all sizes. 
      Our distribution network is efficient and reliable, allowing timely delivery and consistent product availability.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BusinessCard;
